export const FETCH_KPI_START = '[melius][kpi] Get kpi analysis start';
export const FETCH_KPI_SUCCESS = '[melius][kpi] Get kpi analysis success';
export const FETCH_KPI_FAIL = '[melius][kpi] Get kpi analysis failed';
